import AboutUsModule from '../../Components/AboutUs/AboutUsModule'

const AboutUs = () => <AboutUsModule />

export default AboutUs
